(function () {
  'use strict';

  angular.module('app').component('clientsPage', clientListComponent());

  function clientListComponent() {
    return {
      bindings: {},
      controller: ClientListCtrl,
      controllerAs: 'vm',
      templateUrl: './app/ajs/clients/clients-page.component.html',
    };
  }

  ClientListCtrl.$inject = ['$location', 'AbilityService', 'ClientService'];

  function ClientListCtrl($location, AbilityService, ClientService) {
    var vm = this;

    vm.permissions = {
      canCreate: AbilityService.can('create_client_accountadmin'),
    };

    // Methods
    vm.createItem = createItem;
    vm.onShowClient = onShowClient;
    vm.openClientProfiles = openClientProfiles;

    // Initializers
    getClients();

    function getClients() {
      vm.loadingItems = true;
      ClientService.getClients().then(function (data) {
        vm.items = data.items;
        vm.meta = data.meta;

        vm.totalItems = vm.meta.totalItems;

        vm.loadingItems = false;
      });
    }

    function createItem() {
      $location.path('/clients/new');
    }

    function onShowClient(client, mode) {
      $location.path(`/clients/${client.id}`).search({ mode: mode });
    }

    function openClientProfiles() {
      $location.path('/client_profiles/new');
    }
  }
})();
